import type { Environment, PossibleEnvironment } from '../../types/environment'
import { generatedStorefronts } from '../../data/storefronts'

export function getGeneratedStorefronts(env?: PossibleEnvironment) {
  return generatedStorefronts.environments[env || getCurrentEnvironment() as PossibleEnvironment]
}

export function getStorefrontByCountryCode(countryCode: Environment.CountryCode) {
  return getGeneratedStorefronts().find(storefront =>
    storefront.markets.find(market => market.countryCode === countryCode),
  )!
}
